import React, { useRef, useState, useEffect } from "react";
import logo from "./../../assets/img/Template-logo.png";
import mark from "./../../assets/img/mark.jpg";
import { API_Link, validateHeader } from "../../commons/Constants";
import axios from "axios";
import pdficon from "./../../assets/img/pdficon.png";
import { Link } from "react-router-dom";
import "react-quill/dist/quill.snow.css";
import EvidenceTableSingle from "../evidenceTableSingle";
import gif from "../../assets/img/spin.gif";
import { setLoading } from "../../features/setting/apiSlice";
import store from "../../store";
function HTA() {
  const MD5hash = validateHeader();
  const [data, setData] = useState([]);
  const [reviewData, setreviewData] = useState([]);
  const [interventions, setInterventions] = useState([]);
  const [outcomes, setOutcomes] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [punchline, setPunchline] = useState([]);
  const [picoSearchs, setPicoSearches] = useState([]);
  const [abstract, setAbstract] = useState([]);
  const [isLoadingAbstract, setIsLoadingAbstract] = useState(false);
  const [reviewer, setReviewer] = useState([]);
  const [prismaValue, setPrismaValue] = useState([]);
  const [reasons, setReasons] = useState([]);
  const [n, setn] = useState([]);
  const [year, setYear] = useState([]);
  const [title, setTitle] = useState([]);
  const [pages, setPages] = useState([]);
  const [pmid, setPmid] = useState([]);
  const [judgement, setJudgment] = useState([]);
  const [rct, setRct] = useState([]);
  const [findings, setFindings] = useState([]);
  const [multidata, setMultidata] = useState([]);

  const executiveRef = useRef(null);
  const acknowlegementRef = useRef(null);
  const specialistRef = useRef(null);
  const authorRef = useRef(null);
  const committeeRef = useRef(null);
  const reviewerRef = useRef(null);
  const abbreviationRef = useRef(null);
  const disclaimerRef = useRef(null);
  const backgroundRef = useRef(null);
  const featuresRef = useRef(null);
  const policyRef = useRef(null);
  const objectiveRef = useRef(null);
  const methodsRef = useRef(null);
  const resultsRef = useRef(null);
  const discussionRef = useRef(null);
  const conclusionRef = useRef(null);
  const recommendationRef = useRef(null);
  const referencesRef = useRef(null);
  const appendices1Ref = useRef(null);
  const [isLoadingAuthor, setisLoadingAuthor] = useState(false);
  const [maintitle, setMaintitle] = useState([]);
  const [title1, setTitle1] = useState([]);
  const [biasesData, setBiasesData] = useState([]);
  const [isLoadingCharaacteristic, setisLoadingCharaacteristic] =
    useState(false);
  const [judgementData, setJudgmentData] = useState([]);
  const [picoData, setPicoData] = useState([]);
  const [articleData, setArticleData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [finalData, setFinalData] = useState([]);
  const [isLoadingPico, setisLoadingPico] = useState(false);
  const [isLoadingPrisma, setisLoadingPrisma] = useState(false);
  const [isLoadingRisk, setisLoadingRisk] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.token;

  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  };
  // styling
  const styles = {
    tdStyling: {
      backgroundColor: "#eaefef",
      padding: "5px",
      border: "1px solid #000",
      verticalAlign: "top",
    },
    thStyling: {
      border: "1px solid black",
      textAlign: "center",
      color: "#219ebc",
      backgroundColor: "#d9e2f3",
      paddingInline: "20px",
    },
    tableStyling: {
      borderCollapse: "collapse",
      width: "100%",
      padding: "10px",
      height: "auto",
      backgroundColor: "#00b0f0",
      color: "white",
    },
  };

  const getReviews = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;
    const studyId = localStorage.getItem("studyId");
    var config = {
      method: "get",
      url: `${API_Link}getReviews`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
      params: {
        id: studyId,
      },
    };
    axios(config)
      .then(function (response) {
        const APIresponse = response.data.reviews;
        setMaintitle(APIresponse);
        const title1 = APIresponse[0].title;
        setTitle1(title1);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {});
  };

  const getReviewData = () => {
    store.dispatch(
      setLoading({ apiName: "getReviewsData(HTA)", isLoading: true })
    );
    setisLoadingRisk(true);
    setIsLoadingAbstract(true);
    setisLoadingAuthor(true);
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;
    const studyId = localStorage.getItem("studyId");

    var config = {
      method: "get",
      url: `${API_Link}getExtractedReportJson?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const Response1 = response.data.data[0]?.report_json;
        const Response2 = JSON.parse(Response1);
        const ResponseData = Response2.article_data[0];
        setreviewData(ResponseData);
        const abstract = ResponseData.dubious.abstract;
        setAbstract(abstract);

        const interventions = ResponseData.ml.pico_span.interventions;
        setInterventions(interventions);
        const outcomes = ResponseData.ml.pico_span.outcomes;
        setOutcomes(outcomes);

        const punchline = ResponseData.ml.punchlines;
        setPunchline(punchline);
        const n = ResponseData.ml.sample_size;
        setn(n);
        const year = ResponseData.dubious.year;
        setYear(year);
        const title = ResponseData.dubious.title;
        setTitle(title);
        const pages = ResponseData.dubious.pages;
        setPages(pages);
        const pmid = ResponseData.dubious.pmid;
        setPmid(pmid);
        const judgement = ResponseData.ml.bias;
        setJudgment(judgement);

        const rct = ResponseData.ml.rct;

        setRct(rct);
        const findings = ResponseData.ml.finding_direction;
        setFindings(findings);
        const multidata = Response2.article_data;
        setMultidata(multidata);

        setisLoadingAuthor(false);
        setisLoadingRisk(false);
        setIsLoadingAbstract(false);
        store.dispatch(
          setLoading({ apiName: "getReviewsData(HTA)", isLoading: false })
        );
      })
      .catch(function (error) {
        console.log(error);
        setisLoadingAuthor(false);
        setisLoadingRisk(false);
        setIsLoadingAbstract(false);
        store.dispatch(
          setLoading({ apiName: "getReviewsData(HTA)", isLoading: false })
        );
      })
      .finally(function () {
        setisLoadingAuthor(false);
        setisLoadingRisk(false);
        setIsLoadingAbstract(false);
        store.dispatch(
          setLoading({ apiName: "getReviewsData(HTA)", isLoading: false })
        );
      });
  };
  const getReviewEvidence = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;
    const studyId = localStorage.getItem("studyId");

    var config = {
      method: "get",
      url: `${API_Link}getReviewEvidence?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const APIresponse = response.data.evidences;
        setData(APIresponse);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getReview = (stage) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;
    const studyId = localStorage.getItem("studyId");

    // Construct the URL with an optional stage parameter
    let url = `${API_Link}getReview?review_id=${studyId}`;
    if (stage) {
      url += `&stage=${stage}`;
    }
    const config = {
      method: "get",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };

    axios(config)
      .then(function (response) {
        setReviewer(response.data.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    const updatedData = articleData?.map((item, i) =>
      Object.assign({}, item, data[i])
    );
    setFinalData(updatedData);
  }, [articleData, data]);

  const getPicoSearches = () => {
    store.dispatch(
      setLoading({ apiName: "getPicoData(HTA)", isLoading: true })
    );
    setisLoadingPico(true);
    let review_id = localStorage.getItem("studyId");
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;
    var config = {
      method: "get",
      url: `${API_Link}getPicoSearches?review_id=${review_id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        setPicoSearches(
          response.data.picoSearches.filter(
            (item) => item.database !== "RISimport"
          )
        );
        setisLoadingPico(false);
        store.dispatch(
          setLoading({ apiName: "getPicoData(HTA)", isLoading: false })
        );
      })
      .catch(function (error) {
        console.log(error);
        setisLoadingPico(false);
        store.dispatch(
          setLoading({ apiName: "getPicoData(HTA)", isLoading: false })
        );
      })
      .finally(function () {
        setisLoadingPico(false);
        store.dispatch(
          setLoading({ apiName: "getPicoData(HTA)", isLoading: false })
        );
      });
  };

  const PrismaComponent = () => {
    store.dispatch(
      setLoading({ apiName: "getPrismaData(HTA)", isLoading: true })
    );
    setisLoadingPrisma(true);
    const user = JSON.parse(localStorage.getItem("user"));
    const studyId = localStorage.getItem("studyId");
    const token = user?.token;
    var config = {
      method: "get",
      url: `${API_Link}getPrismaCounts?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };

    axios(config)
      .then(function (response) {
        const resData = response;
        setPrismaValue(resData.data.counts);
        // console.warn('reasons', resData.data.counts[0].excluded);
        setReasons(resData.data.counts[0].excluded);
        setisLoadingPrisma(false);
        store.dispatch(
          setLoading({ apiName: "getPrismaData(HTA)", isLoading: false })
        );
      })
      .catch(function (error) {
        setisLoadingPrisma(false);
        console.log(error);
        store.dispatch(
          setLoading({ apiName: "getPrismaData(HTA)", isLoading: false })
        );
      })
      .finally(function () {
        setisLoadingPrisma(false);
        store.dispatch(
          setLoading({ apiName: "getPrismaData(HTA)", isLoading: false })
        );
      });
  };

  const getReviewBiases = () => {
    store.dispatch(
      setLoading({ apiName: "getReviewBiases(HTA)", isLoading: true })
    );
    setisLoadingCharaacteristic(true);
    const user = JSON.parse(localStorage.getItem("user"));
    const studyId = localStorage.getItem("studyId");
    const token = user?.token;
    var config = {
      method: "get",
      url: `${API_Link}getReviewBiases?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };

    axios(config)
      .then(function (response) {
        const resData = response;
        setBiasesData(resData.data.biases);

        setisLoadingCharaacteristic(false);
        store.dispatch(
          setLoading({ apiName: "getReviewBiases(HTA)", isLoading: false })
        );
      })
      .catch(function (error) {
        console.log(error);
        setisLoadingCharaacteristic(false);
        store.dispatch(
          setLoading({ apiName: "getReviewBiases(HTA)", isLoading: false })
        );
      })
      .finally(function () {
        setisLoadingCharaacteristic(false);
        store.dispatch(
          setLoading({ apiName: "getReviewBiases(HTA)", isLoading: false })
        );
      });
  };
  const TableOfContents = () => {
    return (
      <>
        <div
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong> TABLE OF CONTENTS </strong>
        </div>
        <ul className="toc-list">
          <ul className="sub-list">
            <li onClick={() => scrollToSection(disclaimerRef)}>
              Disclaimer and Disclosure{" "}
            </li>
            <li onClick={() => scrollToSection(authorRef)}>Authors</li>
            <li onClick={() => scrollToSection(committeeRef)}>
              Expert committee{" "}
            </li>
            <li onClick={() => scrollToSection(reviewerRef)}>
              External reviewers{" "}
            </li>
            <li onClick={() => scrollToSection(acknowlegementRef)}>
              Acknowledgement{" "}
            </li>
            <li onClick={() => scrollToSection(executiveRef)}>
              Executive summary{" "}
            </li>
            <li onClick={() => scrollToSection(abbreviationRef)}>
              Abbreviations
            </li>
          </ul>
          <li onClick={() => scrollToSection(backgroundRef)}>
            <strong className="list-point">1.0</strong> BACKGROUND{" "}
          </li>
          <li onClick={() => scrollToSection(featuresRef)}>
            <strong className="list-point">2.0</strong> TECHNICAL FEATURES{" "}
          </li>
          <li onClick={() => scrollToSection(policyRef)}>
            <strong className="list-point">3.0</strong> POLICY QUESTION{" "}
          </li>
          <li onClick={() => scrollToSection(objectiveRef)}>
            <strong className="list-point">4.0</strong> OBJECTIVE{" "}
          </li>

          <li onClick={() => scrollToSection(methodsRef)}>
            <strong className="list-point">5.0</strong> METHODS{" "}
          </li>
          <ul className="sub-list">
            <li>5.1 - SEARCHING </li>
            <li>5.2 - SELECTION </li>
          </ul>

          <li onClick={() => scrollToSection(resultsRef)}>
            <strong className="list-point">6.0</strong> RESULTS{" "}
          </li>
          <ul className="sub-list">
            <li>6.1 - EFFICACY/ EFFECTIVENESS </li>
            <li>6.2 - SAFETY </li>
            <li>6.3 - ECONOMIC IMPLICATION </li>
            <li>6.4 - ORGANISATIONAL </li>
            <li>6.5 - SOCIAL/ ETHICAL/ LEGAL </li>
          </ul>

          <li onClick={() => scrollToSection(discussionRef)}>
            <strong className="list-point">7.0</strong> DISCUSSION{" "}
          </li>
          <li onClick={() => scrollToSection(conclusionRef)}>
            <strong className="list-point">8.0</strong> CONCLUSION{" "}
          </li>
          <li onClick={() => scrollToSection(recommendationRef)}>
            <strong className="list-point">9.0</strong> RECOMMENDATION{" "}
          </li>
          <li onClick={() => scrollToSection(referencesRef)}>
            <strong className="list-point">10.</strong>REFERENCES{" "}
          </li>
          <li onClick={() => scrollToSection(appendices1Ref)}>
            <strong className="list-point">11.</strong>APPENDICES
          </li>
          <ul className="sub-list">
            <li>
              Appendix 1 - HIERARCHY OF EVIDENCE FOR EFFECTIVENESS STUDIES/
              DIAGNOSTIC STUDIES{" "}
            </li>
            <li>Appendix 2 - HEALTH TECHNOLOGY ASSESSMENT PROTOCOL </li>
            <li>Appendix 3 - SEARCH STRATEGY </li>
            <li>Appendix 4 - EVIDENCE TABLE (INCLUDED STUDIES) </li>
            <li>Appendix 5 - LIST OF EXCLUDED STUDIES </li>
          </ul>
        </ul>
      </>
    );
  };
  const getReviewArticles = () => {
    store.dispatch(
      setLoading({ apiName: "getReviewArticles(HTA)", isLoading: true })
    );
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;
    const studyId = localStorage.getItem("studyId");
    var config = {
      method: "get",
      url: `${API_Link}getReviewArticles?review_id=${studyId}&fulltext=Yes&exclusion=No`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    setLoader(true);
    axios(config)
      .then(function (response) {
        const resData = response;
        // document.querySelector(".preload").style.display = "none"//stop the load
        const notNull = resData.data.articles.data.filter(
          (article) =>
            (article.current_stage > 3 && article.file_path !== null) ||
            article.source !== null
        );
        const result = notNull?.map(({ id, title, authors, journal }) => ({
          id,
          title,
          authors,
          journal,
        }));
        setArticleData(result);
        setParticipants(result);

        store.dispatch(
          setLoading({ apiName: "getReviewArticles(HTA)", isLoading: false })
        );
      })
      .catch(function (error) {
        console.log(error);
        store.dispatch(
          setLoading({ apiName: "getReviewArticles(HTA)", isLoading: false })
        );
      })
      .finally(function () {
        store.dispatch(
          setLoading({ apiName: "getReviewArticles(HTA)", isLoading: false })
        );
      });
  };

  const getReviewJudgements = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const studyId = localStorage.getItem("studyId");
    const token = user?.token;
    var config = {
      method: "get",
      url: `${API_Link}getReviewJudgements?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };

    axios(config)
      .then(function (response) {
        const resData = response;

        setJudgmentData(resData.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getReviewPico = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const studyId = localStorage.getItem("studyId");
    const token = user?.token;

    var config = {
      method: "get",
      url: `${API_Link}getReviewPicoSentences?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    localStorage.setItem("pdfAId", "");
    axios(config)
      .then(function (response) {
        const resData = response;
        setPicoData(resData.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    getReview();
    getReviewJudgements();
    getReviewBiases();
    getReviewPico();
    getReviewEvidence();
    getReviewArticles();
    getReviewData();
    getPicoSearches();
    PrismaComponent();
    getReviews();
    getReportJson();
  }, []);
  const judgements = judgementData.judgements;
  const picos = picoData.picos;

  const headings1 = [
    { id: 1, headingText: "Random sequence generation" },
    { id: 2, headingText: "Allocation concealment" },
    { id: 3, headingText: "Blinding of participants and personnel" },
    { id: 4, headingText: "Blinding of outcome assessment" },
    { id: 5, headingText: "Incomplete outcome data" },
    { id: 6, headingText: "Selective reporting" },
  ];
  const headings2 = [
    { id: 1, headingText: "Participants" },
    { id: 2, headingText: "Intervention" },
    { id: 3, headingText: "OutComes" },
  ];
  const output = [];
  if (judgementData.judgements) {
    var topLevelKeys = Object.keys(judgementData.judgements);
  }
  if (picoData.picos) {
    var picoIds = Object.keys(picoData.picos);
  }

  const [jsonForReportEditing, setJsonForReportEditing] = useState({});
  const [isLoadingSummary, setisLoadingSummary] = useState(false);
  const getReportJson = async () => {
    setisLoadingSummary(true);
    const studyId = localStorage.getItem("studyId");
    try {
      const config = {
        method: "get",
        url: `${API_Link}getFinalReport`,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
          "misr-auth": MD5hash,
        },
        params: {
          review_id: studyId,
        },
      };

      const response = await axios(config);

      setJsonForReportEditing(response?.data?.data);
      setisLoadingSummary(false);
    } catch (error) {
      setisLoadingSummary(false);

      console.error("Error fetching report:", error);
    }
  };

  function capitalizeSentences(text) {
    if (!text) return "";

    const sentences = text.split(/([.!?]\s*)/).filter(Boolean); // Split and filter out empty strings

    const capitalizedSentences = sentences?.map((sentence, index) => {
      // Trim any leading whitespace and capitalize the first letter
      const trimmedSentence = sentence.trim();
      if (index % 2 === 0) {
        // Check if it's a sentence part
        return (
          trimmedSentence.charAt(0).toUpperCase() + trimmedSentence.slice(1)
        );
      }
      return sentence; // Return punctuation and whitespace as is
    });

    // Join the sentences back together
    return capitalizedSentences.join("");
  }

  return (
    <div className="hta-report-continer">
      {output}
      <p style={{ textAlign: "right" }}>
        <img src={logo} />{" "}
      </p>
      <div style={{ paddingLeft: "10%" }}>
        <div class="hta-report-title">HEALTH TECHNOLOGY ASSESSMENT REPORT</div>

        <div className="hta-study-title">{title1}</div>
        <div
          style={{
            textAlign: "left",
            fontSize: "18px",
            fontWeight: "bold",
            color: "#767171",
            marginBottom: "30px",
          }}
        >
          Malaysian Health Technology Assessment Section (MaHTAS)<br></br>
          Medical Development Division
          <br />
          Ministry of Health Malaysia
          <br />
          006/2020
        </div>
      </div>
      <p style={{ textAlign: "right" }}>
        <img src={mark} />{" "}
      </p>
      <div
        ref={disclaimerRef}
        style={{
          textAlign: "start",
          backgroundColor: "lightgray",
          padding: "20px",
          paddingBottom: "20px",
        }}
      >
        <strong>DISCLAIMER</strong>
        <br />
        This Health Technology Assessment has been developed from analysis,
        interpretation and synthesis of scientific research and/or technology
        assessment conducted by other organizations available at the time of
        development. It also incorporates, where available, Malaysian data, and
        information provided by experts to the Ministry of Health Malaysia.
        While effort has been made to do so, this document may not fully reflect
        all scientific research available. Other relevant scientific findings
        may have been reported since completion of the review. MaHTAS is not
        responsible for any errors, injury, loss or damage arising or relating
        to the use (or misuse) of any information, statement or content of this
        document or any of the source materials..
        <br />
        <p>
          Please contact htamalaysia@moh.gov.my if further information is
          required.{" "}
        </p>
      </div>
      <div
        style={{ textAlign: "left", marginTop: "20px", marginBottom: "30px" }}
      >
        <p>
          <b>Published by:</b>
        </p>
        <p>Malaysian Health Technology Assessment Section (MaHTAS)</p>
        <p>Medical Development Division </p>
        <p>Ministry of Health Malaysia</p>
        <p>Level 4, Block E1, Precinct 1</p>
        <p>Government Office Complex</p>
        <p>62590, Putrajaya</p>
        <p>Tel: 603 8883 1229</p>
        <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
          Available online via the official Ministry of Health Malaysia website:
          http://www.moh.gov.my
        </div>
        <div style={{ padding: "10px", height: "auto" }}>
          <strong>ISBN:</strong>
        </div>
        <div style={{ padding: "10px", height: "auto" }}>
          <strong>eISBN:</strong>
        </div>
        <div style={{ padding: "10px", height: "auto" }}>
          <strong>Copyright:</strong> The copyright owner of this publication is
          the Malaysian Health Technology Assessment Section (MaHTAS). Content
          may be reproduced in any number of copies and in any format or medium
          provided that a copyright acknowledgement to MaHTAS is included and
          the content is not changed, not sold, nor used to promote or endorse
          any product or service and not used in inappropriate or misleading
          context.
        </div>
        <br />
        <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
          This HTA report was approved in HTA&CPG Council Meeting Bil.2/2018 (4
          November 2018).
        </div>
        <div
          style={{
            padding: "10px",
            height: "120px",
            backgroundColor: "#8bc6fc",
          }}
        >
          <strong>SUGGESTED CITATION:</strong> Atikah S, Hanin Farhana K,
          Aidatul Azura AR, Syful Azlie MF and Junainah S. Bone targeting agents
          in preventing skeletal related events for metastatic cancers of solid
          tumours and economic evaluation: Health Technology Assessment.
          Malaysia: Malaysian Health Technology Assessment Section (MaHTAS);
          2019. 179 p. Report No.: 02/2018. eISBN: ……..
        </div>
        <br />
        <div
          style={{
            padding: "10px",
            height: "100px",
            backgroundColor: "#8bc6fc",
          }}
        >
          <strong>DISCLOSURE:</strong> The author of this report has no
          competing interest in this subject and the preparation of this report
          is entirely funded by the Ministry of Health Malaysia
        </div>
        <br />

        {/* Abstract */}

        {/* <div
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
            marginTop: "20px",
          }}
        >
          <strong>Abstract</strong>{" "}
        </div>{" "}
        <br />
        {isLoadingAbstract ? (
          <div className='preload'>
            <img src={gif} alt='Loading...' />
          </div>
        ) : (
          <p
            style={{
              textAlign: "justify",
              fontFamily: "sans-serif",
              fontSize: "16px",
            }}
          >

            {abstract}
          </p>
        )} */}
        <br />

        {isLoadingAuthor ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          (() => {
            const stage4Data = reviewer?.find(
              (stageItem) => stageItem.stage === 4
            );

            return (
              <>
                <div
                  ref={authorRef}
                  style={{
                    padding: "10px",
                    height: "auto",
                    backgroundColor: "#00b0f0",
                    color: "white",
                  }}
                >
                  <strong>AUTHORS</strong>{" "}
                </div>
                {stage4Data?.reviewers?.map((reviewer, index) => (
                  <>
                    <br />
                    <p key={index}>{reviewer?.name} </p>
                    <p>Senior Principal Assistant Director</p>
                    <p>
                      Malaysian Health Technology Assessment Section (MaHTAS)
                    </p>
                    <p>
                      Medical Development Division, Ministry of Health Malaysia
                    </p>
                  </>
                ))}
              </>
            );
          })()
        )}

        <br />

        {(() => {
          const stage1Data = reviewer?.find(
            (stageItem) => stageItem.stage === 1
          );

          return (
            <>
              {stage1Data &&
              stage1Data.reviewers &&
              stage1Data.reviewers.length > 0 ? (
                <>
                  <div
                    ref={specialistRef}
                    style={{
                      padding: "10px",
                      height: "auto",
                      backgroundColor: "#00b0f0",
                      color: "white",
                    }}
                  >
                    <strong>INFORMATION SPECIALIST</strong>
                  </div>
                  {stage1Data?.reviewers?.map((reviewer, index) => (
                    <div key={index}>
                      <br />
                      <p>{reviewer?.name}</p>
                      <p>Medical Assistant Officer</p>
                      <p>
                        Malaysian Health Technology Assessment Section (MaHTAS)
                      </p>
                      <p>
                        Medical Development Division, Ministry of Health
                        Malaysia
                      </p>
                    </div>
                  ))}
                </>
              ) : (
                " " // Optional: add a message when no reviewers are present
              )}
            </>
          );
        })()}
        {/* EXPERT COMMITTEE (alphabetical order) */}

        {/* <div
          ref={committeeRef}
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong> EXPERT COMMITTEE (alphabetical order)</strong>
        </div>
        <br /> */}

        {/* EXTERNAL REVIEWERS (alphabetical order) */}

        {/* <div
          ref={reviewerRef}

          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong> EXTERNAL REVIEWERS (alphabetical order)</strong>
        </div> */}
        <br />

        <div
          ref={acknowlegementRef}
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong> ACKNOWLEDGEMENT </strong>
        </div>
        <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
          The authors of this Health Technology Assessment Report would like to
          express their gratitude and appreciation to the following for their
          contribution and assistance:
        </div>
        <ul>
          <li>
            Health Technology Assessment EXTERNAL REVIEWERS (alphabetical
            order)and Clinical Practice Guidelines Council
          </li>
          <li>Technical Advisory Committee for Health Technology Assessment</li>
        </ul>

        {/* <div
          ref={executiveRef}
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong>  EXECUTIVE SUMMARY </strong>
        </div> */}
        <br />

        <TableOfContents />

        <br />
        <div
          ref={abbreviationRef}
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong> ABBREVIATION (example)</strong>
        </div>

        <table className="abbreviations-table">
          <br />
          <tbody>
            <tr>
              <td>3-D</td>
              <td>Three-dimensional</td>
            </tr>
            <tr>
              <td>AEs</td>
              <td>Adverse events or adverse effects</td>
            </tr>
            <tr>
              <td>BTPNA</td>
              <td>Bronchoscopic transparenchymal nodule access</td>
            </tr>
            <tr>
              <td>CASP</td>
              <td>Critical Appraisal Skills Programme</td>
            </tr>
            <tr>
              <td>CI</td>
              <td>Confidence interval</td>
            </tr>
            <tr>
              <td>COPD</td>
              <td>Chronic obstructive pulmonary disease</td>
            </tr>
            <tr>
              <td>CT</td>
              <td>Computed tomography</td>
            </tr>
            <tr>
              <td>CT-PNB</td>
              <td>CT-guided percutaneous needle biopsy</td>
            </tr>
            <tr>
              <td>CT-TNB</td>
              <td>CT-guided transthoracic needle biopsy</td>
            </tr>
            <tr>
              <td>CXR</td>
              <td>Chest radiography</td>
            </tr>
            <tr>
              <td>DOR</td>
              <td>Diagnostic odds ratio</td>
            </tr>
            <tr>
              <td>EBUS-GS</td>
              <td>Endobronchial ultrasonography with a guide sheath</td>
            </tr>
            <tr>
              <td>ENB</td>
              <td>Electromagnetic navigation bronchoscopy</td>
            </tr>
            <tr>
              <td>ETTNA</td>
              <td>Electromagnetic transthoracic needle aspiration</td>
            </tr>
            <tr>
              <td>HTA</td>
              <td>Health Technology Assessment</td>
            </tr>
            <tr>
              <td>ICER</td>
              <td>Incremental cost-effectiveness ratio</td>
            </tr>
            <tr>
              <td>LR+</td>
              <td>Positive likelihood ratio</td>
            </tr>
            <tr>
              <td>LR−</td>
              <td>Negative likelihood ratio</td>
            </tr>
            <tr>
              <td>MaHTAS</td>
              <td>Malaysian Health Technology Assessment Section</td>
            </tr>
            <tr>
              <td>MNCR</td>
              <td>Malaysia National Cancer Registry</td>
            </tr>
            <tr>
              <td>MOH</td>
              <td>Ministry of Health</td>
            </tr>
            <tr>
              <td>NLST</td>
              <td>National Lung Screening Trial</td>
            </tr>
            <tr>
              <td>PL</td>
              <td>Pulmonary lesion</td>
            </tr>
            <tr>
              <td>POE</td>
              <td>Point of entry</td>
            </tr>
            <tr>
              <td>PPL</td>
              <td>Peripheral pulmonary nodules/ peripheral lung lesions</td>
            </tr>
            <tr>
              <td>QALY</td>
              <td>Quality adjusted life year</td>
            </tr>
            <tr>
              <td>QoL</td>
              <td>Quality of life</td>
            </tr>
            <tr>
              <td>RCT</td>
              <td>Randomised controlled trial</td>
            </tr>
            <tr>
              <td>RES</td>
              <td>Robotic Endoscopy System</td>
            </tr>
            <tr>
              <td>SPN</td>
              <td>Solitary pulmonary nodule</td>
            </tr>
            <tr>
              <td>TBLC</td>
              <td>Transbronchial lung cryobiopsy</td>
            </tr>
            <tr>
              <td>TTNA</td>
              <td>Transthoracic needle aspiration</td>
            </tr>
            <tr>
              <td>US FDA</td>
              <td>United States Food and Drug Administration</td>
            </tr>
            <tr>
              <td>VATS</td>
              <td>Video-assisted thoracoscopic surgery</td>
            </tr>
            <tr>
              <td>VB</td>
              <td>Virtual bronchoscopy</td>
            </tr>
            <tr>
              <td>WHO</td>
              <td>World Health Organization</td>
            </tr>
          </tbody>
        </table>
        <br />
        <div
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong> CHARACTERISTICS OF STUDIES</strong>
        </div>
        <br />

        {isLoadingCharaacteristic ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <>
            {biasesData?.map((biasesItem) => {
              const articleId = biasesItem.article_id.toString();

              // Find corresponding data for the same articleId in topLevelKeys and picoIds
              const topLevelKeyData = topLevelKeys?.includes(articleId)
                ? articleId
                : null;
              const picoData = picoIds?.includes(articleId) ? articleId : null;

              return (
                <div key={articleId}>
                  {/* Biases Data */}
                  <>
                    <p>
                      <strong>{biasesItem.author_year}</strong>
                    </p>
                    <table
                      style={{ border: "1px solid black", padding: "2px" }}
                    >
                      <tr style={{ border: "1px solid black", padding: "2px" }}>
                        <td
                          style={{
                            color: "#219ebc",
                            backgroundColor: "#d9e2f3",
                            padding: "5px",
                          }}
                        >
                          Participants
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            textAlign: "justify",
                            padding: "5px",
                          }}
                        >
                          {biasesItem.population}
                        </td>
                      </tr>
                      <tr style={{ border: "1px solid black", padding: "2px" }}>
                        <td
                          style={{
                            color: "#219ebc",
                            backgroundColor: "#d9e2f3",
                            padding: "5px",
                          }}
                        >
                          Interventions
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            textAlign: "justify",
                            padding: "5px",
                          }}
                        >
                          {biasesItem.interventions}
                        </td>
                      </tr>
                      <tr style={{ border: "1px solid black", padding: "2px" }}>
                        <td
                          style={{
                            color: "#219ebc",
                            backgroundColor: "#d9e2f3",
                            padding: "5px",
                          }}
                        >
                          Outcomes
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            textAlign: "justify",
                            padding: "5px",
                          }}
                        >
                          {biasesItem.outcomes}
                        </td>
                      </tr>
                    </table>
                  </>

                  {/* Top Level Keys */}
                  {topLevelKeyData && (
                    <table className="table table-bordered table-striped mt-4 judgement-table">
                      <thead>
                        <tr>
                          <th style={styles.thStyling}>Bias</th>
                          <th style={styles.thStyling}>Judgment</th>
                          <th style={styles.thStyling}>Support for judgment</th>
                        </tr>
                      </thead>
                      <tbody>
                        {headings1?.map((item, index) => {
                          // Match heading ID to bias field in biasesItem
                          const biasField = {
                            1: biasesItem.random_sequence_generation,
                            2: biasesItem.allocation_concealment,
                            3: biasesItem.participants_personnel_blinding,
                            4: biasesItem.outcome_assessment_blinding,
                            5: biasesItem.incomplete_outcome_data,
                            6: biasesItem.selective_reporting,
                          }[item.id];

                          return (
                            <tr key={index}>
                              <td>{item.headingText}</td>
                              <td>{biasField}</td>
                              <td>
                                {judgements[articleId]?.[item.id]?.map(
                                  (judgement, idx) => (
                                    <div key={idx}>
                                      <span>{judgement.support_text}</span>
                                      <Link
                                        className="Editpdf-icon"
                                        to={`/biasbot/${articleId}`}
                                      >
                                        <img
                                          src={pdficon}
                                          alt=""
                                          height="17px"
                                        />
                                        <span className="tooltiptextannotation">
                                          Jump to Annotation
                                        </span>
                                      </Link>
                                    </div>
                                  )
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}

                  {/* PICO Data */}
                  {picoData && (
                    <table className="table table-bordered table-striped mt-4 judgement-table">
                      <thead>
                        <tr>
                          <th style={styles.thStyling}>PICO</th>
                          <th style={styles.thStyling}>Support for Pico</th>
                        </tr>
                      </thead>
                      <tbody>
                        {headings2?.map((item, index) => (
                          <tr key={index}>
                            <td>{item.headingText}</td>
                            <td>
                              {picos[articleId]?.[index + 1]?.map(
                                (pico, idx) => (
                                  <div key={idx}>
                                    <span>{pico.pico_text}</span>
                                    <Link
                                      to={`/picobot/${articleId}`}
                                      className="Editpdf-icon"
                                    >
                                      <img src={pdficon} alt="" height="17px" />
                                      <span className="tooltiptextannotation">
                                        Jump to Annotation
                                      </span>
                                    </Link>
                                  </div>
                                )
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              );
            })}
          </>
        )}

        <br />

        <br />
        <div
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong>Trail Summaries</strong>
        </div>
        <br />
        <table
          className="table table-striped blue-bg-th-table"
          style={{
            borderCollapse: "collapse",
            width: "100%",
            border: "1px solid black",
            marginTop: "15px",
          }}
        >
          <tr style={{ border: "1px solid black" }}>
            <th style={styles.thStyling}> Title & Authors </th>
            <th style={styles.thStyling}> Participants </th>
            <th style={styles.thStyling}> Interventions </th>
            <th style={styles.thStyling}> Outcomes </th>
            <th style={styles.thStyling}> Punchline </th>
            <th style={styles.thStyling}> Finding </th>
          </tr>
          {interventions?.length !== 0 ||
          participants?.length !== 0 ||
          outcomes?.length !== 0 ||
          punchline?.length !== 0 ? (
            multidata?.map((item) => {
              return (
                <tr>
                  <td style={styles.tdStyling}>
                    {item.grobid.title && (
                      <p>
                        <strong>Title: </strong> {item.grobid.title}
                      </p>
                    )}
                    {item.grobid.authors && (
                      <p>
                        <strong>Authors: </strong>{" "}
                        {item.grobid.authors
                          ?.map(
                            (author) =>
                              `${author.forename
                                .split(" ")
                                ?.map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ")} ${author.lastname
                                .split(" ")
                                ?.map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ")}`
                          )
                          .join(", ")}
                      </p>
                    )}
                    {item.grobid.journal && (
                      <p>
                        <strong>Journal: </strong> {item.grobid.journal}
                      </p>
                    )}
                  </td>
                  <td style={styles.tdStyling}>
                    {item.ml?.pico_span.population?.map((inter) => (
                      <div>
                        <span>{inter}</span>
                      </div>
                    ))}
                  </td>
                  <td style={styles.tdStyling}>
                    {item.ml?.pico_span.interventions?.map((inter) => (
                      <div>
                        <span>{inter}</span>
                      </div>
                    ))}
                  </td>
                  <td style={styles.tdStyling}>
                    {item.ml?.pico_span.outcomes?.map((inter) => (
                      <div>
                        <span>{inter}</span>
                      </div>
                    ))}
                  </td>
                  <td style={styles.tdStyling}>{item.ml.punchlines}</td>
                  <td style={styles.tdStyling}>{item.ml.finding_direction}</td>
                </tr>
              );
            })
          ) : (
            <td colspan="9" className="text-center bg-danger text-light">
              {" "}
              <strong>You don't have any Trail Summaries</strong>{" "}
            </td>
          )}
        </table>
        <br />

        <div
          ref={objectiveRef}
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong>4.0 OBJECTIVE</strong>
        </div>
        <br />
        {isLoadingSummary ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
            {jsonForReportEditing?.objective_summary?.length > 0 &&
              capitalizeSentences(
                jsonForReportEditing?.objective_summary.replace(/<n>/g, "\n")
              )}
          </div>
        )}
        <br />
        <div
          ref={methodsRef}
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong>5.0 METHODS</strong>
        </div>
        <br />
        {isLoadingSummary ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
            {jsonForReportEditing?.method_summary?.length > 0 &&
              capitalizeSentences(
                jsonForReportEditing?.method_summary.replace(/<n>/g, "\n")
              )}
          </div>
        )}

        <br />
        <div
          ref={resultsRef}
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong>6.0 RESULTS</strong>
        </div>
        <br />
        {isLoadingSummary ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
            {jsonForReportEditing?.outcome_summary?.length > 0 &&
              capitalizeSentences(
                jsonForReportEditing?.outcome_summary.replace(/<n>/g, "\n")
              )}
          </div>
        )}
        <br />
        {/* <br />
        <div
          ref={discussionRef}
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong>7.0 DISCUSSION</strong>
        </div>
        <br /> */}
        <div
          ref={conclusionRef}
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong>8.0 CONCLUSION</strong>
        </div>
        <br />
        {isLoadingSummary ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
            {jsonForReportEditing?.conclusion_summary &&
              capitalizeSentences(
                jsonForReportEditing.conclusion_summary.replace(/<n>/g, "\n")
              )}
          </div>
        )}
        <br />
        {/* <div
          ref={recommendationRef}
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong>9.0 RECOMMENDATION</strong>
        </div>
        <br /> */}
        <div
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong>INTERVENTION</strong>
        </div>
        <br />
        {isLoadingSummary ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
            {jsonForReportEditing?.intervention_summary?.length > 0 &&
              capitalizeSentences(
                jsonForReportEditing?.intervention_summary.replace(/<n>/g, "\n")
              )}
          </div>
        )}
        <br />
        {/* <div
          style={{
            padding: '10px',
            height: 'auto',
            backgroundColor: '#00b0f0',
            color: 'white',
          }}
        >
          <strong> 4.0 OBJECTIVE</strong>
        </div> */}
        <div
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong>POPULATION</strong>
        </div>
        <br />
        {isLoadingSummary ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
            {jsonForReportEditing?.population_summary?.length > 0 &&
              capitalizeSentences(
                jsonForReportEditing?.population_summary.replace(/<n>/g, "\n")
              )}
          </div>
        )}
        <br />

        <table ref={referencesRef} style={styles.tableStyling}>
          <tr>
            <th
              style={{
                width: "95%",
                textAlign: "left",
                backgroundColor: "#00b0f0",
                padding: "10px",
              }}
            >
              10.0 REFERENCES{" "}
            </th>
          </tr>
        </table>
        <br />
        <div>
          {multidata?.map((item, index) => {
            return (
              <>
                {item.dubious?.length === 0 ? (
                  <p
                    style={{ justifyContent: "space-between", padding: "2px" }}
                  >
                    {index + 1}. <span style={{ marginLeft: "5px" }}></span>
                    {item?.pubmed?.length === 0 ||
                    !item?.pubmed?.authors ||
                    item?.pubmed?.authors?.length === 0
                      ? ""
                      : item?.pubmed?.authors[0]?.forename}{" "}
                    ,
                    {item?.pubmed?.length === 0 ||
                    !item?.pubmed?.authors ||
                    item?.pubmed?.authors?.length === 0
                      ? ""
                      : item?.pubmed?.authors[0]?.lastname}
                    ,{item?.pubmed?.title} , {item?.pubmed?.pages}, PMID:{" "}
                    {item?.pubmed?.pmid}
                  </p>
                ) : (
                  <p
                    style={{ justifyContent: "space-between", padding: "2px" }}
                  >
                    {index + 1}. <span style={{ marginLeft: "5px" }}></span>
                    {item?.dubious?.length === 0 ||
                    !item?.dubious?.authors ||
                    item?.dubious?.authors?.length === 0
                      ? ""
                      : item?.dubious?.authors[0]?.forename}{" "}
                    ,
                    {item?.dubious?.length === 0 ||
                    !item?.dubious?.authors ||
                    item?.dubious?.authors?.length === 0
                      ? ""
                      : item?.dubious?.authors[0]?.lastname}
                    ,{item?.dubious?.title} , {item.dubious?.pages}, PMID:{" "}
                    {item?.dubious?.pmid}
                  </p>
                )}
              </>
            );
          })}
        </div>
        <br />
        <table style={styles.tableStyling}>
          <tr>
            <th
              style={{
                width: "95%",
                textAlign: "left",
                backgroundColor: "#00b0f0",
                padding: "10px",
              }}
            >
              Risk of bias table{" "}
            </th>
          </tr>
        </table>

        {isLoadingRisk ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <table
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              borderCollapse: "collapse",
              padding: 0,
              marginTop: "10px",
            }}
          >
            <tr className="bias-header-row">
              <th
                style={{
                  verticalAlign: "bottom",
                  textAlign: "left",
                  margin: "20px",
                  padding: "8px",
                  borderBottom: "1px solid #ddd",
                }}
              >
                trial
              </th>
              <th
                style={{
                  verticalAlign: "bottom",
                  textAlign: "left",
                  padding: "8px",
                  borderBottom: "1px solid #ddd",
                }}
              >
                design
              </th>
              {judgement?.map((item, index) => (
                <th
                  key={index}
                  style={{
                    height: "70px",
                    whiteSpace: "normal",
                    padding: "8px",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  <div
                    style={{
                      width: "100px",
                      fontSize: "14px",
                      padding: "10px",
                    }}
                  >
                    <span>{item.domain}</span>
                  </div>
                </th>
              ))}
            </tr>
            {multidata?.map((item, index) => (
              <tr key={index}>
                <td
                  style={{
                    fontSize: "14px",
                    padding: "10px",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  {item?.grobid?.length === 0
                    ? ""
                    : item?.grobid?.authors?.length > 0
                    ? `${item?.grobid?.authors[0]?.lastname
                        .split(" ")
                        ?.map(
                          (word) => word.charAt(0).toUpperCase() + word.slice(1)
                        )
                        .join(" ")}`
                    : ""}{" "}
                  {item?.grobid?.year ? item?.grobid?.year : item?.pubmed?.year}
                </td>
                <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                  {item?.ml?.rct?.is_rct === false ? (
                    <p>Not Rct</p>
                  ) : (
                    <p>Rct</p>
                  )}
                </td>
                {item?.ml?.bias?.map((bi, biasIndex) => (
                  <td
                    key={biasIndex}
                    style={{
                      backgroundColor:
                        bi.judgement === "high/unclear" ? "red" : "green",
                      color: "white",
                      textAlign: "center",
                      width: "40px",
                      padding: "10px",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {bi.judgement === "high/unclear" ? "?" : "+"}
                  </td>
                ))}
              </tr>
            ))}
          </table>
        )}

        <br />

        <div
          ref={appendices1Ref}
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong>
            APPENDIX 1: HIERARCHY OF EVIDENCE FOR EFFECTIVENESS STUDIES/
            DIAGNOSTIC STUDIES{" "}
          </strong>
        </div>
        <br />
        <div style={{ backgroundColor: "lightgray", padding: "20px" }}>
          <table style={{ borderCollapse: "collapse", width: "100%" }}>
            <tr>
              <th></th>
              <th style={{ width: "95%", textAlign: "center" }}>
                {" "}
                DESIGNATION OF LEVELS OF EVIDENCE
              </th>
            </tr>
            <br />
            <tr>
              <th>1</th>
              <th style={{ width: "95%", textAlign: "left" }}>
                {" "}
                Evidence obtained from at least one properly designed randomised
                controlled trial.
              </th>
            </tr>
            <br />
            <tr>
              <th>II-I</th>
              <th style={{ width: "95%", textAlign: "left" }}>
                {" "}
                Evidence obtained from well-designed controlled trials without
                randomisation.
              </th>
            </tr>
            <br />
            <tr>
              <th>II-2 </th>
              <th style={{ width: "95%", textAlign: "left" }}>
                {" "}
                Evidence obtained from well-designed cohort or case-control
                analytic studies, preferably from more than one centre or
                research group.
              </th>
            </tr>
            <br />

            <tr>
              <th>II-3 </th>
              <th style={{ width: "95%", textAlign: "left" }}>
                {" "}
                Evidence obtained from multiple time series with or without the
                intervention. Dramatic results in uncontrolled experiments (such
                as the results of the introduction of penicillin treatment in
                the 1940s) could also be regarded as this type of evidence.
              </th>
            </tr>
            <br />

            <tr>
              <th>III</th>
              <th style={{ width: "95%", textAlign: "left" }}>
                {" "}
                Opinions or respected authorities, based on clinical experience;
                descriptive studies and case reports; or reports of expert
                committees.
              </th>
            </tr>
            <br />
            <br />
            <tr>
              <th></th>
              <th style={{ width: "95%", textAlign: "left" }}>
                {" "}
                SOURCE: US/CANADIAN PREVENTIVE SERVICES TASK FORCE (Harris 2001)
              </th>
            </tr>
            <br />
          </table>
        </div>
        <br />

        <div
          style={{
            padding: "10px",
            height: "auto",
            backgroundColor: "#00b0f0",
            color: "white",
          }}
        >
          <strong>APPENDIX 4: EVIDENCE TABLE </strong>
        </div>
        <EvidenceTableSingle />
        <br />

        <br />

        {isLoadingPrisma ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <div>
            {prismaValue &&
              prismaValue?.length > 0 &&
              prismaValue?.map(() => {
                return (
                  <>
                    <div
                      style={{
                        padding: "10px",
                        height: "auto",
                        backgroundColor: "#00b0f0",
                        color: "white",
                      }}
                    >
                      <strong>Prisma Flowchart</strong>
                    </div>
                    <div className="container">
                      <div className="row pt-5">
                        <div className="col-sm-12 col-md-3 col-lg-2 mt-2">
                          <div className="identification">
                            <p className="text">Identification</p>
                          </div>
                        </div>
                        <div className="col-col-sm-12 col-md-9 col-lg-10">
                          <div className="row mb-3">
                            <div className="col-sm-12 col-md-12 col-lg-6 mt-2 ">
                              <div className="Number1972">
                                Number of records identified through electronic
                                databases searching (n=
                                {prismaValue[0].onlineSearch})
                              </div>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-6 mt-2">
                              <div className="Number53">
                                Number of additional records identified from
                                other sources (n={prismaValue[0].otherSources})
                              </div>
                            </div>
                          </div>

                          <div className="row ">
                            <div className="col-6">
                              <span className="arrow-icon-prisma">
                                {/* <i className='bi bi-arrow-down-short'></i> */}
                                ↓
                              </span>
                            </div>
                            <div className="col-6">
                              <span className="arrow-icon-prisma">↓</span>
                            </div>
                          </div>

                          <div className="row pt-2 mb-3 ">
                            <div className="col-12">
                              <div className="Num2055">
                                Number of records after duplicates removed (n=
                                {prismaValue[0].abstract_articles_count})
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12 col-md-3"></div>
                        <div className="col-sm-12 col-md-9 col-lg-10">
                          <span className="arrow-icon-prisma">↓</span>
                        </div>
                      </div>

                      <div className="row ">
                        <div className="col-sm-12 col-md-3 col-lg-2 mt-2">
                          <div className="Screening">
                            <p className="text">Screening</p>
                          </div>
                          <div className="row pt-2">
                            <div className="col-sm-12 col-md-3 col-lg-2 ">
                              <div className="included">
                                <p className="text">included</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-col-sm-12 col-md-9 col-lg-10">
                          <div className="row mb-3">
                            <div className="col-sm-12 col-md-12 col-lg-1 "></div>
                            <div className="col-sm-12 col-md-12 col-lg-5 mt-2">
                              <div className="num_1925">
                                Number of records screened (n=
                                {prismaValue[0].abstract_articles_count})
                              </div>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-1">
                              <span className="arrow-icon-prisma text-icon arrow-icon-prisma-right">
                                {/* <i className='bi bi-arrow-down-short'></i> */}
                                →
                              </span>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-5 mt-2 ">
                              <div className="num1200">
                                Number of records excluded (n=
                                {prismaValue[0].abstract_articles_count -
                                  prismaValue[0].fulltext_articles_count}
                                )
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-7">
                              <span className="arrow-icon-prisma">
                                {/* <i className='bi bi-arrow-down-short'></i> */}
                                ↓
                              </span>
                            </div>
                          </div>

                          <div className="row ">
                            <div className="col-sm-12 col-md-12 col-lg-1 col-xxl-1 "></div>
                            <div className="col-sm-12 col-md-12 col-lg-5 col-xxl-5 ">
                              <div className="row mb-3">
                                <div className="col">
                                  <div className="num685">
                                    Number of full-text articles assessed for
                                    eligibility (n=
                                    {prismaValue[0].fulltext_articles_count})
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-12 col-md-12 col-lg-12">
                                <span className="arrow-icon-prisma">↓</span>
                              </div>
                              <div className="row ">
                                <div className="col">
                                  <div className="mt-2 yelllowbox">
                                    Number of full-text articles included in
                                    qualitative synthesis (n=
                                    {prismaValue[0].included_articles_count})
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-1 col-xxl-1 ">
                              <span className="arrow-icon-prisma text-icon arrow-icon-prisma-right">
                                →
                              </span>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-5 col-xxl-5">
                              <div className="num432">
                                Number of full-text articles excluded (n=
                                {prismaValue[0]?.fulltext_articles_count -
                                  prismaValue[0]?.included_articles_count}
                                ) <br></br> Reasons:
                                {reasons &&
                                  reasons
                                    .filter(
                                      (exclusion) => exclusion.stage === 3
                                    )
                                    ?.map(({ purpose, total }, index) => {
                                      return (
                                        <small>
                                          <br></br>
                                          {purpose?.label} (n = {total})
                                        </small>
                                      );
                                    })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
}
export default HTA;
